export class Grid {
    constructor(pxHeight, pxWidth, name) {
        this.name = name || 'Grid'; 
        this.idIndex = 0;

        this.showRects = true;
        this.showGuides = true;
        this.showMargins = true;
        this.showHcenter = true;
        this.showVcenter = true;

        this.width = pxWidth || 400;
        this.height = pxHeight || 560;
        
        this.columns = 4;
        this.rows = 8;

        this.marginTop = 10;
        this.marginBottom = 10;
        this.marginLeft = 10;
        this.marginRight = 10;

        this.hgutter = 5;
        this.vgutter = 5;

        this.columnColor = '#FF0000';
        this.columnOpacity = 0.10;
        this.rowColor = '#FF0000';
        this.rowOpacity = 0.10;
        this.guideColor = '#FF0000';
        this.guideOpacity = 1;
        this.marginColor = '#0000FF';
        this.marginOpacity = 1
        this.centreLineColor = '#000000';
        this.centreLineOpacity = 1;
    }
}
